import details from './details'

export default {
  title: 'Kingsejong',
  slug: 'kingsejong',
  createdAt: '1610446012941',
  description: '',
  details,
  tint: '#2E3192'
}
